import {
  createBrowserRouter,
  Outlet,
  useMatches,
  Navigate,
  redirect,
  useLocation,
} from 'react-router-dom'
import Main from '../Main'
// import { BalanceDistribution } from '../Pages/BalanceDistribution'
import { AddAccount } from '../Pages/AddAccount'
import { Withdraw } from '../Pages/WithdrawRequest'
import { WithdrawList } from '../Pages/WithdrawList'
import { BankAccounts } from '../Pages/BankAccounts'
import { FinancialClosing } from '../Pages/FinancialClosing'
import { AbandonedCartRoute } from '../Pages/AbandonedCart'
import { Reviews } from '../Pages/Reviews'
import { Spotify } from '../Pages/Spotify'
import { Event } from '../Pages/Event'
import { Events } from '../Pages/Events'
import { Page404 } from '../Pages/Page404'
import Auth from '../Pages/Auth'
import { BalanceAdvance } from '../Pages/BalanceAdvance'
import { ReceiptsCalendar } from '../Pages/ReceiptsCalendar'
import { TicketValidator } from '../Pages/TicketValidator'
import Header from '../components/Header'
import Menu from '../components/MenuHamburger/menu'
import { Container, MenuContainer } from '../styles/styles'
import { Pixel } from '../Pages/Pixel'
import { useAuth } from '../hooks/auth'
import { Resume } from '../Pages/Resume'
import { FullLoader } from '../components/Loader'
import { CourtesyRequest } from '../Pages/CoutersyRequest'
import { CourtesyList } from '../Pages/CourtesyList'
import { SalesSummaryRoute } from '../Pages/SalesReport'
import { AccessSummaryRoute } from '../Pages/AccessReport'
import { NewAdvanceAnalytics } from '../Pages/NewAdvanceAnalytics'
import { EventComparison } from '../Pages/EventComparison'
import { Bordero } from '../Pages/Bordero'
import { LegacyAdvanceAnalytics } from '../Pages/LegacyAdvanceAnalytics'
import { EventsCourtesy } from '../Pages/CourtesyEvents'
import InternalLayout from '../Pages/Interno/InternalLayout'
import { OsList } from '../Pages/Interno/OsList'
import { OsAnalytics } from '../Pages/Interno/OsAnalytics'
import { PrevisoesCarteira } from '../Pages/Interno/Previsoes/Carteira'
import { PrevisoesEstudo } from '../Pages/Interno/Previsoes/Estudo'
import { PrevisoesEvento } from '../Pages/Interno/Previsoes/Evento'
import { PrevisoesGmv } from '../Pages/Interno/Previsoes/Gmv'
import { PrevisoesLotes } from '../Pages/Interno/Previsoes/Lotes'
import { PrevisoesQualidade } from '../Pages/Interno/Previsoes/Qualidade'
import { PrevisoesSimulador } from '../Pages/Interno/Previsoes/Simulador'
import { OsDetail } from '../Pages/Interno/OsDetail'
import { OsResolver } from '../Pages/Interno/OsResolver'
import { Tecnicos } from '../Pages/Interno/Tecnicos'
import { Config as OsConfigPage } from '../Pages/Interno/Config'
import { ImportacaoOs } from '../Pages/Interno/ImportacaoOs'
import { EstoqueHoje } from '../Pages/Interno/Estoque/Hoje'
import { EstoquePosicao } from '../Pages/Interno/Estoque/Posicao'
import { EstoqueSolicitar } from '../Pages/Interno/Estoque/Solicitar'
import { EstoqueMinhas } from '../Pages/Interno/Estoque/Minhas'
import { EstoqueMinhaSolicitacao } from '../Pages/Interno/Estoque/MinhaSolicitacao'
import { EstoqueFila } from '../Pages/Interno/Estoque/Fila'
import { EstoquePedido } from '../Pages/Interno/Estoque/Pedido'
import { EstoqueRemessas } from '../Pages/Interno/Estoque/Remessas'
import { EstoqueRemessa } from '../Pages/Interno/Estoque/Remessa'
import { EstoqueVinculos } from '../Pages/Interno/Estoque/Vinculos'
import { EstoqueVinculo } from '../Pages/Interno/Estoque/Vinculo'
import { EstoqueHistorico } from '../Pages/Interno/Estoque/Historico'
import { EstoqueMais } from '../Pages/Interno/Estoque/Mais'
import { EstoqueRazao } from '../Pages/Interno/Estoque/Razao'
import { EstoqueEquipamentos } from '../Pages/Interno/Estoque/Equipamentos'
import { EstoqueEquipamento } from '../Pages/Interno/Estoque/Equipamento'
import { EstoqueTransferencias } from '../Pages/Interno/Estoque/Transferencias'
import { EstoqueTransferencia } from '../Pages/Interno/Estoque/Transferencia'
import { EstoqueNovaTransferencia } from '../Pages/Interno/Estoque/NovaTransferencia'
import { EstoqueInventarios } from '../Pages/Interno/Estoque/Inventarios'
import { EstoqueInventario } from '../Pages/Interno/Estoque/Inventario'
import { EstoqueBaixas } from '../Pages/Interno/Estoque/Baixas'
import { EstoqueCatalogo } from '../Pages/Interno/Estoque/Catalogo'
import { EstoqueNotificacoes } from '../Pages/Interno/Estoque/Notificacoes'
import { EstoqueEntrada } from '../Pages/Interno/Estoque/Entrada'
import { EstoqueOcorrencias } from '../Pages/Interno/Estoque/Ocorrencias'
import { ESTOQUE_PERM } from '../types/estoque'
import InternalGuard from '../components/InternalGuard'
import { LOCAL_EXECUTION } from '../utils/featureFlag'

const Layout = () => {
  const { status, verifyJwt } = useAuth()
  const location = useLocation()
  const matches = useMatches()
  if (
    !LOCAL_EXECUTION &&
    status === 'not-logged' &&
    location.pathname !== '/auth'
  ) {
    console.log('User not logged, redirecting to auth page')
    return <Navigate to="/auth" replace />
  }

  if (
    !LOCAL_EXECUTION &&
    status !== 'logged' &&
    location.pathname !== '/auth'
  ) {
    return <FullLoader />
  }

  // Sessão expirada (token vencido) enquanto ainda 'logged': em vez de deixar o usuário
  // navegando sem dados (requests tomando 401), manda pro /auth, que valida e renova o
  // token pelo SSO dentro do fluxo do React. Mesmo guard já usado no InternalLayout.
  if (
    !LOCAL_EXECUTION &&
    status === 'logged' &&
    !verifyJwt() &&
    location.pathname !== '/auth'
  ) {
    return <Navigate to="/auth" replace />
  }

  const menu = matches.some((match: any) => Boolean(match.handle?.menu))

  return (
    <>
      <Header menu={menu} />
      <Container>
        {menu && (
          <MenuContainer>
            <Menu />
          </MenuContainer>
        )}
        <Outlet />
      </Container>
    </>
  )
}

const router = createBrowserRouter([
  {
    element: <Layout />,
    children: [
      {
        path: '*',
        element: <Page404 />,
        loader: (route: any) => {
          let id = route.params['*']
          let isnum = /^\d+$/.test(id)

          if (isnum === true) {
            return redirect(`/events/${id}`)
          }

          return null
        },
        handle: {
          crumb: () => 'Not Found',
        },
      },
      {
        path: '/error',
        element: <Page404 />,
        handle: {
          crumb: () => 'Not Found',
        },
      },
      {
        path: '/auth',
        element: <Auth />,
      },
      {
        path: '/',
        element: <Resume />,
      },
      {
        path: '/start/withdraw/withdraw-request/:id',
        loader: (route: any) => {
          return redirect(`/events/${route.params.id}/withdraw/requests/new`)
        },
      },
      {
        path: '/start/withdraw/add-account',
        loader: () => {
          return redirect(`/finance/add-account`)
        },
      },
      {
        path: '/events',
        element: <Events />,
        handle: {
          crumb: () => 'Eventos',
          menu: false,
        },
      },
      {
        path: '/start',
        element: <Resume />,
        handle: {
          crumb: () => 'Início',
          menu: false,
        },
      },
      {
        path: '/events/:id',
        element: <Event />,
        handle: {
          crumb: () => 'Eventos',
          menu: true,
        },
      },
      {
        path: '/events/:id/abandoned-cart',
        element: <AbandonedCartRoute />,
        handle: {
          crumb: () => 'Carrinho abandonado',
          menu: true,
        },
      },
      {
        path: '/events/:id/reviews',
        element: <Reviews />,
        handle: {
          crumb: () => 'Avaliações',
          menu: true,
        },
      },
      {
        path: '/events/:id/spotify',
        element: <Spotify />,
        handle: {
          crumb: () => 'Spotify',
          menu: true,
        },
      },
      {
        path: '/events/:id/dashboard',
        element: <Main />,
        handle: {
          crumb: () => 'Dashboard',
          menu: true,
        },
      },
      {
        path: '/events/:id/financial',
        element: <FinancialClosing />,
        handle: {
          crumb: () => 'Fechamento',
          menu: true,
        },
      },
      {
        path: '/events/:id/pixel',
        element: <Pixel />,
        handle: {
          crumb: () => 'Gerenciamento de Tags/Pixels',
          menu: true,
        },
      },
      {
        path: '/events/:id/courtesy',
        element: <CourtesyRequest />,
        handle: {
          crumb: () => 'Cortesias',
          menu: true,
        },
      },
      {
        path: '/events/:id/access-sumary',
        element: <AccessSummaryRoute />,
        handle: {
          crumb: () => 'Relatório de Acesso',
          menu: true,
        },
      },
      {
        path: '/events/:id/sales-sumary',
        element: <SalesSummaryRoute />,
        handle: {
          crumb: () => 'Relatório de Vendas',
          menu: true,
        },
      },
      {
        path: '/events/:id/courtesy/list',
        element: <CourtesyList />,
        handle: {
          crumb: () => 'Cortesias',
          menu: true,
        },
      },
      {
        path: '/events/:id/validador',
        element: <TicketValidator permissions={['DP18']} />,
        handle: {
          crumb: () => 'Validador de Ingressos',
          menu: true,
        },
      },
      {
        path: 'events/:id/withdraw',
        handle: {
          crumb: () => 'Início',
        },
        children: [
          {
            index: true,
            element: <Navigate to={'requests/list'} replace />,
          },
          {
            path: 'requests',
            handle: {
              crumb: () => 'Saque',
            },
            children: [
              {
                index: true,
                element: <Navigate to={'list'} replace />,
              },
              {
                path: 'list',
                element: <WithdrawList />,
                handle: {
                  crumb: () => 'Saldo evento',
                  menu: true,
                },
              },
              {
                path: 'new',
                element: <Withdraw />,
                handle: {
                  crumb: () => 'Solicitar Saque',
                  menu: true,
                },
              },
              {
                path: 'advance',
                element: <BalanceAdvance />,
                handle: {
                  crumb: () => 'Solicitar Antecipação',
                  menu: true,
                },
              },
              {
                path: 'calendar',
                element: <ReceiptsCalendar />,
                handle: {
                  crumb: () => 'Calendário de Recebimentos',
                  menu: true,
                },
              },
            ],
          },
        ],
      },
      {
        path: '/finance',
        handle: {
          crumb: () => 'Financeiro',
        },
        children: [
          {
            index: true,
            element: <Navigate to={'/finance/bank-accounts'} replace />,
          },
          {
            index: true,
            path: 'bank-accounts',
            element: <BankAccounts />,
            handle: {
              crumb: () => 'Contas Bancárias',
            },
          },
          {
            path: 'add-account',
            element: <AddAccount />,
            handle: {
              crumb: () => 'Adicionar Conta',
            },
          },
        ],
      },
      {
        path: '/courtesy',
        handle: {
          crumb: () => 'Cortesias',
        },
        children: [
          {
            index: true,
            element: <Navigate to={'/events'} replace />,
          },
          {
            index: true,
            path: 'events',
            element: <EventsCourtesy />,
            handle: {
              crumb: () => 'Eventos',
            },
          },
        ],
      },
      {
        path: '/hidden/advance/analytics',
        element: <LegacyAdvanceAnalytics />,
        handle: {
          crumb: () => 'Análise de dados',
        },
      },
      {
        path: '/hidden/new-advance/analytics',
        element: <NewAdvanceAnalytics />,
        handle: {
          crumb: () => 'Análise de dados',
        },
      },
      {
        path: '/analytics/comparativo',
        element: <EventComparison permissions={['DP19']} />,
        handle: {
          crumb: () => 'Comparativo de Eventos',
        },
      },
      {
        path: '/analytics/bordero',
        element: <Bordero permissions={['DP20']} />,
        handle: {
          crumb: () => 'Borderô',
        },
      },
    ],
  },
  {
    element: <InternalLayout />,
    children: [
      {
        path: '/interno',
        element: <Navigate to="/interno/os" replace />,
      },
      {
        path: '/interno/os',
        element: (
          <InternalGuard need={['OS1']}>
            <OsList />
          </InternalGuard>
        ),
        handle: { crumb: () => 'Ordens de Serviço' },
      },
      {
        path: '/interno/os/importacao',
        element: (
          <InternalGuard need={['OS4']}>
            <ImportacaoOs />
          </InternalGuard>
        ),
        handle: { crumb: () => 'Importação em lote' },
      },
      {
        path: '/interno/analytics',
        element: (
          <InternalGuard need={['OS9']}>
            <OsAnalytics />
          </InternalGuard>
        ),
        handle: { crumb: () => 'Analytics de Operações' },
      },
      // 5897 — Previsões de vendas
      {
        path: '/interno/previsoes',
        element: (
          <InternalGuard need={['PV1']}>
            <PrevisoesCarteira />
          </InternalGuard>
        ),
        handle: { crumb: () => 'Previsões · Carteira' },
      },
      {
        path: '/interno/previsoes/evento/:id',
        element: (
          <InternalGuard need={['PV1']}>
            <PrevisoesEvento />
          </InternalGuard>
        ),
        handle: { crumb: () => 'Previsões · Evento' },
      },
      {
        path: '/interno/previsoes/lotes',
        element: (
          <InternalGuard need={['PV1']}>
            <PrevisoesLotes />
          </InternalGuard>
        ),
        handle: { crumb: () => 'Previsões · Lotes em risco' },
      },
      {
        path: '/interno/previsoes/gmv',
        element: (
          <InternalGuard need={['PV1']}>
            <PrevisoesGmv />
          </InternalGuard>
        ),
        handle: { crumb: () => 'Previsões · GMV da BD' },
      },
      {
        path: '/interno/previsoes/qualidade',
        element: (
          <InternalGuard need={['PV1']}>
            <PrevisoesQualidade />
          </InternalGuard>
        ),
        handle: { crumb: () => 'Previsões · Qualidade do modelo' },
      },
      {
        path: '/interno/previsoes/estudo',
        element: (
          <InternalGuard need={['PV1']}>
            <PrevisoesEstudo />
          </InternalGuard>
        ),
        handle: { crumb: () => 'Previsões · Como o público compra' },
      },
      {
        path: '/interno/previsoes/simulador',
        element: (
          <InternalGuard need={['PV1']}>
            <PrevisoesSimulador />
          </InternalGuard>
        ),
        handle: { crumb: () => 'Previsões · Simulador de evento' },
      },
      {
        path: '/interno/os/evento/:eventoId',
        element: (
          <InternalGuard need={['OS1']}>
            <OsResolver />
          </InternalGuard>
        ),
      },
      {
        path: '/interno/os/:id',
        element: (
          <InternalGuard need={['OS1']}>
            <OsDetail />
          </InternalGuard>
        ),
        handle: { crumb: () => 'Ordem de Serviço' },
      },
      {
        path: '/interno/tecnicos',
        element: (
          <InternalGuard need={['OS8']}>
            <Tecnicos />
          </InternalGuard>
        ),
        handle: { crumb: () => 'Técnicos' },
      },
      {
        path: '/interno/config',
        element: (
          <InternalGuard need={['OS5']}>
            <OsConfigPage />
          </InternalGuard>
        ),
        handle: { crumb: () => 'Configurações' },
      },
      // OP-3605 — Estoque e Logística (permissões ESL*, módulo próprio)
      {
        path: '/interno/estoque',
        element: (
          <InternalGuard need={[ESTOQUE_PERM.VISUALIZAR]}>
            <EstoqueHoje />
          </InternalGuard>
        ),
        handle: { crumb: () => 'Hoje' },
      },
      {
        path: '/interno/estoque/posicao',
        element: (
          <InternalGuard need={[ESTOQUE_PERM.VISUALIZAR]}>
            <EstoquePosicao />
          </InternalGuard>
        ),
        handle: { crumb: () => 'Posição de estoque' },
      },
      {
        path: '/interno/estoque/fila',
        element: (<InternalGuard need={[ESTOQUE_PERM.VISUALIZAR]}><EstoqueFila /></InternalGuard>),
        handle: { crumb: () => 'Fila da logística' },
      },
      {
        path: '/interno/estoque/fila/:id',
        element: (<InternalGuard need={[ESTOQUE_PERM.VISUALIZAR]}><EstoquePedido /></InternalGuard>),
        handle: { crumb: () => 'Pedido' },
      },
      {
        path: '/interno/estoque/remessas',
        element: (<InternalGuard need={[ESTOQUE_PERM.VISUALIZAR]}><EstoqueRemessas /></InternalGuard>),
        handle: { crumb: () => 'Remessas' },
      },
      {
        path: '/interno/estoque/remessas/:id',
        element: (<InternalGuard need={[ESTOQUE_PERM.VISUALIZAR]}><EstoqueRemessa /></InternalGuard>),
        handle: { crumb: () => 'Remessa' },
      },
      {
        path: '/interno/estoque/razao',
        element: (<InternalGuard need={[ESTOQUE_PERM.VISUALIZAR]}><EstoqueRazao /></InternalGuard>),
        handle: { crumb: () => 'Razão' },
      },
      {
        path: '/interno/estoque/equipamentos',
        element: (<InternalGuard need={[ESTOQUE_PERM.VISUALIZAR]}><EstoqueEquipamentos /></InternalGuard>),
        handle: { crumb: () => 'Equipamentos' },
      },
      {
        path: '/interno/estoque/equipamentos/:id',
        element: (<InternalGuard need={[ESTOQUE_PERM.VISUALIZAR]}><EstoqueEquipamento /></InternalGuard>),
        handle: { crumb: () => 'Equipamento' },
      },
      {
        // Estática antes da dinâmica: "nova" não é um id.
        path: '/interno/estoque/transferencias/nova',
        element: (<InternalGuard need={[ESTOQUE_PERM.TRANSFERIR]}><EstoqueNovaTransferencia /></InternalGuard>),
        handle: { crumb: () => 'Nova transferência' },
      },
      {
        path: '/interno/estoque/transferencias',
        element: (<InternalGuard need={[ESTOQUE_PERM.VISUALIZAR]}><EstoqueTransferencias /></InternalGuard>),
        handle: { crumb: () => 'Transferências' },
      },
      {
        path: '/interno/estoque/transferencias/:id',
        element: (<InternalGuard need={[ESTOQUE_PERM.VISUALIZAR]}><EstoqueTransferencia /></InternalGuard>),
        handle: { crumb: () => 'Transferência' },
      },
      {
        path: '/interno/estoque/inventarios',
        element: (<InternalGuard need={[ESTOQUE_PERM.VISUALIZAR]}><EstoqueInventarios /></InternalGuard>),
        handle: { crumb: () => 'Inventário' },
      },
      {
        path: '/interno/estoque/inventarios/:id',
        element: (<InternalGuard need={[ESTOQUE_PERM.VISUALIZAR]}><EstoqueInventario /></InternalGuard>),
        handle: { crumb: () => 'Contagem' },
      },
      {
        path: '/interno/estoque/baixas',
        element: (<InternalGuard need={[ESTOQUE_PERM.VISUALIZAR]}><EstoqueBaixas /></InternalGuard>),
        handle: { crumb: () => 'Baixas' },
      },
      {
        path: '/interno/estoque/catalogo',
        element: (<InternalGuard need={[ESTOQUE_PERM.VISUALIZAR]}><EstoqueCatalogo /></InternalGuard>),
        handle: { crumb: () => 'Catálogo' },
      },
      {
        path: '/interno/estoque/entrada',
        element: (<InternalGuard need={[ESTOQUE_PERM.PATRIMONIO]}><EstoqueEntrada /></InternalGuard>),
        handle: { crumb: () => 'Entrada' },
      },
      {
        path: '/interno/estoque/ocorrencias',
        element: (<InternalGuard need={[ESTOQUE_PERM.VISUALIZAR]}><EstoqueOcorrencias /></InternalGuard>),
        handle: { crumb: () => 'Ocorrências' },
      },
      {
        path: '/interno/estoque/vinculos',
        element: (<InternalGuard need={[ESTOQUE_PERM.VISUALIZAR]}><EstoqueVinculos /></InternalGuard>),
        handle: { crumb: () => 'Contratos' },
      },
      {
        path: '/interno/estoque/vinculos/:id',
        element: (<InternalGuard need={[ESTOQUE_PERM.VISUALIZAR]}><EstoqueVinculo /></InternalGuard>),
        handle: { crumb: () => 'Contrato' },
      },
      {
        path: '/interno/estoque/mais',
        element: (
          <InternalGuard need={[ESTOQUE_PERM.VISUALIZAR, ESTOQUE_PERM.SOLICITAR]}>
            <EstoqueMais />
          </InternalGuard>
        ),
        handle: { crumb: () => 'Mais' },
      },
      {
        path: '/interno/estoque/solicitacoes',
        element: (<InternalGuard need={[ESTOQUE_PERM.VISUALIZAR]}><EstoqueHistorico /></InternalGuard>),
        handle: { crumb: () => 'Histórico de solicitações' },
      },
      {
        path: '/interno/estoque/solicitar',
        element: (<InternalGuard need={[ESTOQUE_PERM.SOLICITAR]}><EstoqueSolicitar /></InternalGuard>),
        handle: { crumb: () => 'Nova solicitação' },
      },
      {
        path: '/interno/estoque/minhas',
        element: (<InternalGuard need={[ESTOQUE_PERM.SOLICITAR]}><EstoqueMinhas /></InternalGuard>),
        handle: { crumb: () => 'Minhas solicitações' },
      },
      {
        path: '/interno/estoque/minhas/:id',
        element: (<InternalGuard need={[ESTOQUE_PERM.SOLICITAR]}><EstoqueMinhaSolicitacao /></InternalGuard>),
        handle: { crumb: () => 'Solicitação' },
      },
      {
        path: '/interno/estoque/notificacoes',
        element: (<InternalGuard need={[ESTOQUE_PERM.NOTIFICACOES]}><EstoqueNotificacoes /></InternalGuard>),
        handle: { crumb: () => 'Notificações' },
      },
    ],
  },
])

export default router
